import List from './actions/list';
import Find from './actions/find';
import Create from './actions/create';
import Update from './actions/update';
import Delete from './actions/delete';
import Resource from './resource';

export default class Form extends Resource {
  get resourceName() {
    return 'form';
  }

  get resourcesName() {
    return 'forms';
  }

  async systemApps() {
    const options = {
      method: 'GET',
      path: this.collectionAction('system_apps', null),
    };

    const body = await this.call(options);

    return JSON.parse(body);
  }

  async changePermissions(changes) {
    const options = {
      method: 'POST',
      path: this.collectionAction('change_permissions'),
      body: { change: changes },
    };

    const body = await this.call(options);

    if (body) {
      return JSON.parse(body)[this.resourceName];
    }

    return {};
  }
}

// @ts-ignore
List.includeInto(Form);
// @ts-ignore
Find.includeInto(Form);
// @ts-ignore
Create.includeInto(Form);
// @ts-ignore
Update.includeInto(Form);
// @ts-ignore
Delete.includeInto(Form);
